<template>
  <ValidationObserver
    ref="edit_box_form"
    slim
    v-slot="{ handleSubmit, reset }"
  >
    <form
      class="edit_box_form"
      @submit.prevent="handleSubmit(updateBox)"
      @reset.prevent="reset"
      autocomplete="off"
    >
      <div class="form_fields">
        <div class="form_btns top_btns">
          <button type="button" class="secondary_btn" @click="cancelChanges">Cancel</button>
          <button aria-label="save box" class="primary_btn">Save</button>
        </div>

        <div class="field_block half_field">
          <ValidationProvider
            name="name"
            v-slot="{ errors }"
            slim
            rules="required"
          >
            <label :class="{ has_error: errors[0] }">
              <span class="field_name">Box Name</span>
              <input type="text" v-model="editData.name" @input="editBoxHelper(false)" />
              <span class="error_message">{{ errors[0] ? "Required field" : "" }}</span>
            </label>
          </ValidationProvider>
        </div>

        <div class="field_block half_field">
          <ValidationProvider
            name="seats"
            v-slot="{ errors }"
            slim
            rules="required"
          >
            <label :class="{ has_error: errors[0] }">
              <span class="field_name">Seats</span>
              <input
                type="number"
                min="1"
                v-model="editData.seats"
                @input="editBoxHelper(true)"
              />
              <span class="error_message">{{ errors[0] }}</span>
            </label>
          </ValidationProvider>
        </div>

        <span class="divider"></span>

        <div class="field_block">
          <span class="field_name">
            Rotation
            <span v-if="editData.rotation && editData.rotation !== 0">
              ({{ Math.round(editData.rotation * 100) / 100 }})
            </span>
          </span>
          <range-slider
            class="slider"
            min="-180"
            max="180"
            step="1"
            v-model="editData.rotation"
            @input="changeRotation"
          >
          </range-slider>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import RangeSlider from "vue-range-slider";
import _ from "lodash";
import "vue-range-slider/dist/vue-range-slider.css";
import {
  rotateBox,
  updateBoxStage,
  cancelBoxChanges,
} from "@/helpers/box/generator";
import { deselectGroup, unFreezeAllGroups } from "@/helpers/utils";

export default {
  props: {
    editBox: {
      type: Object,
      default: () => ({}),
    },
    popup: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    popup(opened) {
      if (!opened) {
        cancelBoxChanges(this.editBox);
      }
    },
  },
  data() {
    return {
      editData: {},
    };
  },
  created() {
    this.editData = _.cloneDeep(this.editBox);
  },
  methods: {
    editBoxHelper(ticket) {
      if (ticket) {
        const value = String(this.editData.seats).replace(/\D/g, "");
        this.editData.seats = value ? +value : 0;
      }

      const { layerId } = this.editBox;
      updateBoxStage(layerId, {
        boxData: this.editBox,
        newData: this.editData,
      });
    },
    updateBox() {
      deselectGroup();
      this.$emit("closePopup");
      unFreezeAllGroups();
    },
    changeRotation() {
      rotateBox(this.editData.rotation, this.editBox.layerId, this.editData);
    },
    cancelChanges() {
      cancelBoxChanges(this.editBox);
      this.$emit("closePopup", this.editBox);
      unFreezeAllGroups();
    },
  },
  components: {
    RangeSlider,
  },
};
</script>

<style></style>
